import {
    collection, getDocs, addDoc, deleteDoc, doc, getDoc, getCountFromServer,
    serverTimestamp, updateDoc, query, where, increment
} from "firebase/firestore";
import { ref, getDownloadURL, listAll } from 'firebase/storage';
import { storage } from '../firebase/config';
import { db } from "../firebase/config.js";

export async function getAllLiveEvents() {
    try {
        const eventsRef = collection(db, "events");
        const q = query(eventsRef, where("isLive", "==", true));
        const querySnapshot = await getDocs(q);
        const allEvents = []
        querySnapshot.forEach((doc) => {
            allEvents.push({ id: doc.id, ...doc.data() })
        });
        return { success: true, events: allEvents };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}

export async function getAllEvents() { //admin only
    try {
        const querySnapshot = await getDocs(collection(db, "events"));
        const allEvents = []
        querySnapshot.forEach((doc) => {
            allEvents.push({ id: doc.id, ...doc.data() })
        });
        return { success: true, events: allEvents };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}


export async function getEventById(eventId) {
    try {
        const docRef = doc(db, "events", eventId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return { success: true, eventData: docSnap.data() };
        } else {
            return { success: false, error: 'Document not found' };
        }
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}

export async function getEventPlayers(eventId) {
    try {
        const eventPlayersRef = collection(db, "events", eventId, "players");
        const querySnapshot = await getDocs(eventPlayersRef);
        const allEventPlayers = []
        querySnapshot.forEach((doc) => {
            allEventPlayers.push({ id: doc.id, ...doc.data() })
        });
        return { success: true, players: allEventPlayers };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}

export async function addEvent(eventProps) {
    try {
        const docRef = await addDoc(collection(db, 'events'), {
            ...eventProps
        });

        console.log('Event added with ID:', docRef.id);
        return docRef.id;
    } catch (error) {
        console.error('Error adding event:', error);
        throw error;
    }
}

export async function getEventImages(eventId) {
    try {
        const folderRef = ref(storage, `eventPictures/${eventId}/`);
        const result = await listAll(folderRef);
        const urlPromises = result.items.map((itemRef) => getDownloadURL(itemRef));
        const urls = await Promise.all(urlPromises);
        return { success: true, imageUrls: urls };
    } catch (error) {
        console.error('Error fetching event images:', error);
        return { success: false, error: error.message };
    }
}

export async function getEventCoverImage(eventId, imageName) {
    try {
        const folderRef = ref(storage, `eventPictures/${eventId}/${imageName}`);
        const url = await getDownloadURL(folderRef);
        return { success: true, imageUrl: url };
    } catch (error) {
        console.error('Error fetching event cover image:', error);
        return { success: false, error: error.message };
    }
}

export async function getAllEventsCoverImages(events) {
    const promises = events.map(async (event) => {
        try {
            const imageRef = ref(storage, `eventPictures/${event.id}/${event.coverImage}`);
            const url = await getDownloadURL(imageRef);
            return { ...event, coverImageUrl: url };
        } catch (error) {
            console.error(`Failed to load image for event ${event.id}`, error);
            return { ...event, coverImageUrl: null }; // fallback or placeholder
        }
    });
    return await Promise.all(promises);
}


export async function getEventsCount() {
    try {
        const coll = collection(db, "events");
        const snapshot = await getCountFromServer(coll);
        const count = snapshot.data().count
        return { success: true, count };
    } catch (error) {
        console.error('Error getting count:', error);
        return { success: false, error: error.message };
    }
}

export async function deleteEvent(eventId) {
    try {
        await deleteDoc(doc(db, "events", eventId));
        return { success: true, eventId };
    } catch (error) {
        console.error('Error getting event:', error);
        return { success: false, error: error.message };
    }
}

export async function updateEventisLive(eventId, isLive) {
    try {
        const eventDocRef = doc(db, "events", eventId);

        await updateDoc(eventDocRef, {
            isLive: isLive,
            updatedAt: serverTimestamp()
        });

        return { success: true, eventObj: { id: eventId, isLive: isLive } };
    } catch (error) {
        console.error('Error getting event:', error);
        return { success: false, error: error.message };
    }
}


export async function getBadgeSVGs() {
  try {
    const folderRef = ref(storage, 'badges/');
    const result = await listAll(folderRef);

    // Filter only .svg files
    const svgItems = result.items.filter((itemRef) => itemRef.name.endsWith('.svg'));

    const urlPromises = svgItems.map((itemRef) => getDownloadURL(itemRef));
    const urls = await Promise.all(urlPromises);

    return { success: true, svgUrls: urls };
  } catch (error) {
    console.error('Error fetching badge SVGs:', error);
    return { success: false, error: error.message };
  }
}